import "./Industries.module.css";
import Header from "@/reusable_sections/Header";
import ArchitectureHero from "./sections/ArchitectureHero";
import Industries from "./sections/Industries";
import RequirementsCTA from "./sections/RequirementsCTA";
import Footer from "@/reusable_sections/Footer";
export default function IndustriesPage() {
  return <div>
      <Header />
      <ArchitectureHero />
      <Industries />
      <RequirementsCTA />
      <Footer />
    </div>;
}